<template>
    <div class="quote">
        <img :src="quoteImage" class="quote-image" />
        <div class="quote__text">
            {{ text }} &mdash;
            <span>Björn Bylund, VD, Retail Only</span>
            <img :src="quoteSignStart" class="quote-sign-start" />
            <img :src="quoteSignEnd" class="quote-sign-end" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, toRefs, computed } from 'vue'

export default defineComponent({
    name: 'Services',
    props: {
        text: String,
    },
    setup(props) {
        const { text } = toRefs(props)

        const quoteImage = computed(() => {
            return require('@/assets/images/bjorn-bylund-quote-image.png')
        })

        const quoteSignStart = computed(() => {
            return require('@/assets/icons/quote-start.svg')
        })

        const quoteSignEnd = computed(() => {
            return require('@/assets/icons/quote-end.svg')
        })

        const quote = computed(() => {
            return text
        })

        return {
            quote,
            quoteImage,
            quoteSignStart,
            quoteSignEnd,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins';
@import '../../styles/config';

.quote {
    margin-top: 4rem;
    display: flex;
    align-items: center;

    @include mQ(700px) {
        flex-direction: column;
        margin-top: 2rem;
    }

    &-image {
        margin: 0 2rem;
        width: 200px;
        height: 200px;
        box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.05);

        @include mQ(700px) {
            width: 130px;
            height: 130px;
            margin-bottom: 1rem;
        }
    }

    &__text {
        position: relative;
        font-family: $font-family-header;
        font-weight: 200;
        font-size: 1.4rem;
        color: $font-color-main-grey;

        @include mQ(700px) {
            margin-left: 0;
            font-size: 1.1rem;
        }

        & span {
            font-weight: 700;
        }
    }
}

.quote-sign-start {
    position: absolute;
    left: -3rem;
    top: -4.5rem;

    @include mQ(700px) {
        display: none;
    }
}

.quote-sign-end {
    position: absolute;
    right: -1rem;
    bottom: -4.5rem;

    @include mQ(700px) {
        display: none;
    }
}
</style>
